import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENT_POOL_ID,
};

export default new CognitoUserPool(poolData);
